export default "__VITE_ASSET__kZUrPkm4__"